(function () {
  var config = window.a4yOpenAIAdsConfig;

  if (!config || !config.enabled || !config.pixelId) return;

  var storageKey = 'a4y_openai_ads_attribution_v1';
  var trackedQueryKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'fbclid',
    'msclkid',
    'ttclid',
  ];

  function safeParse(json) {
    if (!json) return {};

    try {
      return JSON.parse(json);
    } catch (error) {
      return {};
    }
  }

  function getStoredAttribution() {
    return safeParse(window.sessionStorage.getItem(storageKey));
  }

  function truncate(value, maxLength) {
    if (typeof value !== 'string') return value;
    return value.length > maxLength ? value.slice(0, maxLength) : value;
  }

  function captureAttribution() {
    var current = getStoredAttribution();
    var next = Object.assign({}, current);
    var url = new URL(window.location.href);
    var landingPath = truncate(url.pathname + url.search, 500);
    var hasTrackedParam = false;

    trackedQueryKeys.forEach(function (key) {
      var value = url.searchParams.get(key);
      if (!value) return;

      hasTrackedParam = true;
      next[key] = truncate(value, 150);
    });

    if (!next.first_seen_at) {
      next.first_seen_at = new Date().toISOString();
    }

    if (!next.first_landing_page) {
      next.first_landing_page = landingPath;
    }

    if (!next.original_referrer && document.referrer) {
      next.original_referrer = truncate(document.referrer, 500);
    }

    if (hasTrackedParam) {
      next.last_tracked_landing_page = landingPath;
      next.last_tracked_at = new Date().toISOString();
    }

    next.last_seen_at = new Date().toISOString();
    next.last_seen_page = landingPath;
    next.pixel_id = config.pixelId;

    window.sessionStorage.setItem(storageKey, JSON.stringify(next));
    return next;
  }

  function buildAttributionPayload() {
    var attribution = getStoredAttribution();
    var compact = {};

    Object.keys(attribution).forEach(function (key) {
      if (attribution[key] === '' || attribution[key] == null) return;
      compact[key] = attribution[key];
    });

    return compact;
  }

  function ensureHiddenInput(form, name, value) {
    if (!form || !name) return;

    var selector = 'input[type="hidden"][name="' + name.replace(/"/g, '\\"') + '"]';
    var input = form.querySelector(selector);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value;
  }

  function syncCartAttributionForm(form) {
    if (!form) return;

    var attribution = buildAttributionPayload();
    var source = attribution.utm_source || 'direct';

    ensureHiddenInput(form, 'attributes[openai_ads_pixel_id]', config.pixelId);
    ensureHiddenInput(form, 'attributes[openai_ads_source]', truncate(source, 100));
    ensureHiddenInput(form, 'attributes[openai_ads_attribution]', truncate(JSON.stringify(attribution), 1000));
  }

  function syncAllCartForms() {
    document.querySelectorAll('form[action*="/cart"], #cart, #CartDrawer-Form').forEach(syncCartAttributionForm);
  }

  window.a4yOpenAIAds = window.a4yOpenAIAds || {};
  window.a4yOpenAIAds.pixelId = config.pixelId;
  window.a4yOpenAIAds.getAttribution = buildAttributionPayload;
  window.a4yOpenAIAds.syncCartForms = syncAllCartForms;
  window.a4yOpenAIAds.measure = function (eventName, payload) {
    if (typeof window.oaiq !== 'function') return false;
    window.oaiq('measure', eventName, payload || {});
    return true;
  };

  captureAttribution();
  syncAllCartForms();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      syncAllCartForms();
    });
  }

  document.addEventListener('shopify:section:load', syncAllCartForms);
})();
